import {Href} from "./href";
import {BaseEntity} from "./BaseEntity";
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {DateValidator} from "../validation/DateValidator";
import moment from "moment";

export class ProjectTimeSliceForm extends UntypedFormGroup {
	readonly effectiveFrom: AbstractControl;
	readonly effectiveUntil: AbstractControl;
	readonly probability: AbstractControl;
	originalEffectiveUntil: AbstractControl;

	constructor(projectTimeSlice: ProjectTimeSlice) {
		super(
			{
				effectiveFrom: new UntypedFormControl(
					projectTimeSlice.effectiveFrom ? moment(projectTimeSlice.effectiveFrom) : null,
					{validators: [Validators.required, DateValidator.validDate], updateOn: "blur"},
				),
				effectiveUntil: new UntypedFormControl(
					projectTimeSlice.effectiveUntil ? moment(projectTimeSlice.effectiveUntil) : null,
					{updateOn: "blur", validators: [DateValidator.validDate]},
				),
				probability: new UntypedFormControl(projectTimeSlice.probability, {validators: [Validators.required]}),
			},
			{validators: [DateValidator.fromToDate("effectiveFrom", "effectiveUntil")]},
		);

		this.effectiveFrom = this.controls["effectiveFrom"];
		this.effectiveUntil = this.controls["effectiveUntil"];
		this.probability = this.controls["probability"];
	}
}

export class ProjectTimeSlice extends BaseEntity {
	effectiveFrom: string;
	effectiveUntil: string;
	probability: string;
	id?: number;
	_links: Link;
}

/**
 * ProjectTimeSlice link model
 */
export class Link {
	self: Href;
	projectTimeSlice: Href;
}
